/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Sq_Rev1_RoleInputs */

const en_funnel_sq_rev1_role = /** @type {(inputs: Funnel_Sq_Rev1_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PhD candidate`)
};

const es_funnel_sq_rev1_role = /** @type {(inputs: Funnel_Sq_Rev1_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doctoranda`)
};

/**
* | output |
* | --- |
* | "PhD candidate" |
*
* @param {Funnel_Sq_Rev1_RoleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_sq_rev1_role = /** @type {((inputs?: Funnel_Sq_Rev1_RoleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Sq_Rev1_RoleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_sq_rev1_role(inputs)
	return en_funnel_sq_rev1_role(inputs)
});